// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__ItT2b","slider":"ToggleSwitch_slider__fBFoX","round":"ToggleSwitch_round__kCoqi"};